import { useState } from "react";

type ErrorsProps<T> = Partial<Record<keyof T, string>>;

type UseFormFieldsReturn<T = { [k: string]: string }> = [
  Partial<T>,
  ErrorsProps<T>,
  (field: keyof T, value: any) => void,
  React.Dispatch<React.SetStateAction<Partial<T>>>,
  React.Dispatch<React.SetStateAction<Partial<Record<keyof T, string>>>>
];

export function useFormFields<T = { [k: string]: string }>(params?: {
  onChange?: (newValue: Partial<T>) => void;
  initialValues?: Partial<T>;
}) {
  const [fields, setFields] = useState<Partial<T>>(params?.initialValues || {});
  const [errors, setErrors] = useState<ErrorsProps<T>>({});

  const onChangeField = (field: keyof T, value: any) => {
    setFields((prev) => {
      prev = { ...prev, [field]: value };
      setErrors((errors) => {
        delete errors[field];
        return { ...errors };
      });
      params?.onChange?.(prev);
      return prev;
    });
  };

  return [
    fields,
    errors,
    onChangeField,
    setFields,
    setErrors,
  ] as UseFormFieldsReturn<T>;
}
